import { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';

//
import { fileUploader } from '../../../../../../../_helpers/_methods';

/**
 *
 */
function ImageOffCanvas({ show, title, handleSave, handleClose }) {
  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const handleImageUpload = async () => {
    try {
      setIsLoading(true);
      const response = await fileUploader(file, 'image');
      handleSave(response.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    handleSave({ file: null });
  };

  return (
    <Offcanvas show={show} onHide={handleClose} placement={'end'}>
      <Offcanvas.Header closeButton className="border-bottom">
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="mb-3">
          <label className="d-block" style={{ fontSize: '24px' }} htmlFor="logo">
            Image
          </label>
          <input
            type="file"
            id="logo"
            accept="image/png, image/jpg, image/jpeg"
            onChange={(e) => setFile(e.target.files)}
          />
        </div>

        <button className="mt-3 btn btn-primary w-100" onClick={handleImageUpload} disabled={!file}>
          {isLoading ? 'loading ...' : 'Upload'}
        </button>

        <div className="border-top mt-3 pt-4">
          <button className="btn btn-outline-danger" onClick={handleReset}>
            Reset
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default ImageOffCanvas;
